import React from 'react';

/**
 * Icons.
 */
import FormIcon from 'assets/icons/form.png';
import ApproveIcon from 'assets/icons/approve.png';
import DonationIcon from 'assets/icons/donation.png';
import OpenBookIcon from 'assets/icons/open-book.png';

/**
 * Style.
 */
import './landing-step.scss';

const stepIcon = {
  0: FormIcon,
  1: ApproveIcon,
  2: DonationIcon,
  3: OpenBookIcon,
};

const LandingStep = ({ step, title, children }) => (
  <div className="landing-step-wrapper">
    <div className="landing-step-icon">
      <img src={stepIcon[step]} alt="" />
    </div>
    <div className="landing-step-title">
      {title}
    </div>
    <div className="landing-step-content">
      {children}
    </div>
  </div>
);

export default LandingStep;
